export const randomPosition = (val?: number) => {
  const random = Math.random() * 0.000099;
  const str = String(0.0) + String(random);
  const plusMinus = Math.random() * 2 ? +str : -str;
  return val ? val + plusMinus : plusMinus;
};
